import { render } from "./WebOrderDetailsView.vue?vue&type=template&id=3c44375b&scoped=true"
import script from "./WebOrderDetailsView.vue?vue&type=script&lang=js"
export * from "./WebOrderDetailsView.vue?vue&type=script&lang=js"

import "./WebOrderDetailsView.vue?vue&type=style&index=0&id=3c44375b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c44375b"]])

export default __exports__